import { API_PREFIX, defaultRequest } from '@/config/api'
import axios from 'axios'

const axiosApiInstance = axios.create({
    baseURL: API_PREFIX || window.location.origin,
    ...defaultRequest
})

export default axiosApiInstance
